import { useState } from 'react';
import { shallowEqual } from 'react-redux';

import { Heading, Icon, Image, Modal, Paragraph, Tabs } from '@zillow/constellation-10';
import { IconInfoFilled } from '@zillow/constellation-icons';

import AppSelectors from '../../../selectors/AppSelectors';
import { useSelector } from '../../../selectors/useSelector';

import ApplicantSummaryMWeb from '../../../images/applicationSample/mweb/ApplicantSummaryMWeb.png';
import BackgroundCheckMWeb from '../../../images/applicationSample/mweb/BackgroundCheckMWeb.png';
import CreditReportMWeb from '../../../images/applicationSample/mweb/CreditReportMWeb.png';
import ApplicantSummaryWeb from '../../../images/applicationSample/web/ApplicantSummaryWeb.png';
import BackgroundCheckWeb from '../../../images/applicationSample/web/BackgroundCheckWeb.png';
import CreditReportWeb from '../../../images/applicationSample/web/CreditReportWeb.png';
import { TabPanel } from './styles';

const { makeIsScreenMobile } = AppSelectors;

const ApplicationSampleModal = ({ onClose }: { onClose: () => void }) => {
  const isScreenMobile = useSelector((state) => makeIsScreenMobile(state), shallowEqual);

  const [state, setState] = useState({ selected: 'summary-tab' });

  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<Heading level={6}>Application sample</Heading>}
      size={{ base: 'fullScreen', md: 'md' }}
      body={
        <>
          <Paragraph css={{ paddingBottom: '400' }}>
            <Icon css={{ color: 'icon.accent.blue.strong' }}>
              <IconInfoFilled />
            </Icon>{' '}
            These documents are for viewing purposes only.
          </Paragraph>
          <Tabs.Root
            appearance="file"
            selected={state.selected}
            onSelectedChange={(selected: string) => setState({ selected })}
          >
            <Tabs.List aria-label="sample-application-files">
              <Tabs.Tab value="summary-tab">Applicant Summary</Tabs.Tab>
              <Tabs.Tab value="credit-tab">Credit Report</Tabs.Tab>
              <Tabs.Tab value="background-tab">Background Check</Tabs.Tab>
            </Tabs.List>
            <TabPanel value="summary-tab">
              <Image
                src={isScreenMobile ? ApplicantSummaryMWeb : ApplicantSummaryWeb}
                alt="Applicant Summary sample"
                css={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </TabPanel>
            <TabPanel value="credit-tab">
              <Image
                src={isScreenMobile ? CreditReportMWeb : CreditReportWeb}
                alt="Credit Report sample"
                css={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </TabPanel>
            <TabPanel value="background-tab">
              <Image
                src={isScreenMobile ? BackgroundCheckMWeb : BackgroundCheckWeb}
                alt="Background Check sample"
                css={{ width: '100%', height: 'auto', display: 'block' }}
              />
            </TabPanel>
          </Tabs.Root>
        </>
      }
    />
  );
};

export default ApplicationSampleModal;
